$(document).ready(function(){
      $('.my-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '30px',
        arrows: true,
        dots: false,
        speed: 300,
        infinite: true,
        autoplaySpeed: 5000,
        autoplay: true,
        prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/Vector_5.png?v=1721654274" alt="Previous"></button>',
        nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/Vector_5.png?v=1721654274" alt="Next"></button>',
        responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
      });

  $('.testimonial-blocks-outer').slick({
  dots: true,
    arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/slider-left-arrow.svg?v=1722423693" /></button>',
        nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/slider-right-arrow.svg?v=1722423622" /></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      arrows: false,
        adaptiveHeight: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      arrows: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
      }
    }
  ]
});

  $('.collection-slider-blocks').slick({
  dots: false,
    arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
    prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/slider-left-arrow.svg?v=1722423693" /></button>',
        nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/slider-right-arrow.svg?v=1722423622" /></button>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1
      }
    }
  ]
});
$(document).ready(function(){

  $('.logo-slider-mobile').slick({
    dots: false,
    arrows: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
    autoplay: true,
    rtl: false,
    prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/slider-left-arrow.svg?v=1722423693" /></button>',
        nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/slider-right-arrow.svg?v=1722423622" /></button>',
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        dots: true
      }
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 2,
        dots: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        dots: true
      }
    }
  ]
  });
});
  $('.richtext-sliderblocks').slick({
  dots: true,
    arrows: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
    adaptiveHeight: true,
    prevArrow: '<button class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/slider-left-arrow.svg?v=1722423693" /></button>',
        nextArrow: '<button class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0589/1788/0001/files/slider-right-arrow.svg?v=1722423622" /></button>',
    responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }
      ]
});

    });


$('.slider-main').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  asNavFor: '.thumbnail-slider',
  infinite: false
});

$('.thumbnail-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  asNavFor: '.slider-main',
  vertical: true,         
  verticalSwiping: true,
  dots: false,
  focusOnSelect: true,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0589/1788/0001/files/up-arrow.png?v=1724225460' /></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0589/1788/0001/files/down-arrow.png?v=1724224733' /></button>",
  responsive: [
{
      breakpoint: 750,
      settings: {
        vertical: false,         
  verticalSwiping: false,
        slidesToShow: 5
      }
    },
    {
      breakpoint: 580,
      settings: {
        vertical: false,         
  verticalSwiping: false,
        slidesToShow: 3
      }
    }
    ]
});

$(document).on('click','.product-form__input--swatch input',function() {
  var clickedCOLOR = $(this).data('colorname');
  var varImage = $(this).data('variant-image');
  var slideIndex = $('.product-gallery .slider-main .slide-main[data-image="'+varImage+'"]').data('slick-index');
  $('.product-gallery .slider-main').slick('slickGoTo', slideIndex);
});

var defaultColor = $('.product-form__input--swatch input:checked').data('colorname');
var defaultvarImage = $('.product-form__input--swatch input:checked').data('variant-image');
  var defaultslideIndex = $('.product-gallery .slider-main .slide-main[data-image="'+defaultvarImage+'"]').data('slick-index');
  $('.product-gallery .slider-main').slick('slickGoTo', defaultslideIndex);

$(document).on('click','.product-gallery .thumbnail-slider .thumbnail-slide',function() {
  var imagename = $(this).data('image');
  $('.product-form__input--swatch input[data-variant-image="'+imagename+'"]').trigger('click');
});
$(document).ready(function(){
  var url=window.location.href;
if(url="https://www.deweyclothing.com/pages/faq-s#customid4"){
 $('#payment5').click();
  $('.accordion.blockaccord-5 .block-text.accordarea-3 .accordion__header').click();
}

});
